<template>
  <div>
    <div v-if="!this.$store.getters.showTreeComponent">
      <div v-if="isLoading_adminQuestions"/>
      <div v-else>
      <BlocQuestions />
      <SaveQuestionButton style="display:flex;justify-content:flex-start"/>
      <br />
      </div>
    </div>
    <div v-if="this.$store.getters.showTreeComponent">
      <TreeComponent style="overflow-x: auto;width:100%" />
      <br /><br />
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import BlocQuestions from '@/components/question/BlocQuestions'
import SaveQuestionButton from '@/components/question/components/SaveQuestionButton'
import TreeComponent from '@/components/question/section/tree/TreeComponent'
export default {
  name: 'QuestionsComponents',
  components: {
    TreeComponent,
    SaveQuestionButton,
    BlocQuestions
  },
  computed: {
    ...mapGetters(['showTreeComponent', 'isLoading_adminQuestions'])
  },
  watch: {
    showTreeComponent () {
      this.$store.commit('UPDATE_ALL_FOLDING', {data: []})
    }
  },
  created () {
    this.$store.commit('IS_LOADING_QUESTION_ADMIN')
    this.$store.commit('SHOW_TREE_COMPONENT', false)
    this.$store.commit('UPDATE_ALL_FOLDING', {data: []})
    this.$store.dispatch(
      'getSondage',
      this.$store.state.sondage.configure_questions_sondage
    )
    this.$store.dispatch('getQuestionsAdmin')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionsComponent.vue